export default class SearchAndFilter {
  constructor(el) {
    this.el = el;
    this.initialize();
  }

  initialize() {
    this.bindUI();
    this.bindEvents();
  }

  bindUI() {
    this.ui = {};
    this.ui.$input = this.el.querySelector('.js-search-input');
    this.ui.$select = this.el.querySelector('.js-search-select');
    this.ui.$items = [...this.el.querySelectorAll('.js-search-item')];
    this.filteredItems = [...this.ui.$items];
  }

  bindEvents() {
    this.onFocusIn = this.onFocusIn.bind(this);
    this.onFocusOut = this.onFocusOut.bind(this);
    this.onKeyup = this.onKeyup.bind(this);
    this.onChange = this.onChange.bind(this);
    this.ui.$input.addEventListener('focusin', this.onFocusIn);
    this.ui.$input.addEventListener('focusout', this.onFocusOut);
    this.ui.$input.addEventListener('keyup', this.onKeyup);
    this.ui.$select.addEventListener('change', this.onChange);
  }

  onKeyup(e) {
    const keyword = e.target.value.toLowerCase();
    for (let i = 0; i < this.filteredItems.length; i++) {
      const name = this.filteredItems[i].getAttribute('data-name');

      if (name.toLowerCase().indexOf(keyword) > -1) {
        this.filteredItems[i].classList.remove('is-hidden');
      } else {
        this.filteredItems[i].classList.add('is-hidden');
      }
    }
  }

  onFocusIn() {
    this.ui.$input.classList.add('is-focused');
  }

  onFocusOut() {
    if (this.ui.$input.value == '') {
      this.ui.$input.classList.remove('is-focused');
    }
  }

  onChange() {
    const value = this.ui.$select.options[this.ui.$select.selectedIndex].value;

    for (let i = 0; i < this.ui.$items.length; i++) {
      const type = this.ui.$items[i].getAttribute('data-type');

      if (type !== value && value !== 'All') {
        this.ui.$items[i].classList.add('is-hidden');
        this.filteredItems = this.remove(this.filteredItems, this.ui.$items[i]);
      } else {
        this.ui.$items[i].classList.remove('is-hidden');
        this.filteredItems.push(this.ui.$items[i]);
      }
    }
  }

  remove(arrOriginal, elementToRemove) {
    return arrOriginal.filter((el) => {
      return el !== elementToRemove;
    });
  }

  unmount() {
    this.ui.$input.removeEventListener('focusin', this.onFocusIn);
    this.ui.$input.removeEventListener('focusout', this.onFocusOut);
    this.ui.$input.removeEventListener('keyup', this.onKeyup);
    this.ui.$select.removeEventListener('change', this.onChange);
  }
}
